function GuildControl() {
	return (
	     <div>Guild Control

	     </div>
	)
}

export default GuildControl
